import SliderContainer from './SliderContainer';

export default SliderContainer;
